import React, { useState, useEffect } from "react";
import {
  Plus,
  Trash2,
  Eye,
  ShoppingCart,
  ArrowLeft,
  Download,
  Printer,
} from "lucide-react";
import html2pdf from "html2pdf.js";
import logo from "../assets/logo03132025-removebg.png";

const QuotationModal = ({ onClose }) => {
  const [formData, setFormData] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const existingCartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  useEffect(() => {
    // Simulate cart data since localStorage isn't available in this environment
    const existingCartItems =
      JSON.parse(localStorage.getItem("cartItems")) || [];

    const initialFormData = {
      name: existingCartItems[0]?.name || "",
      mobile: existingCartItems[0]?.mobile || "",
      address: existingCartItems[0]?.address || "",
      pincode: existingCartItems[0]?.pincode || "",
      selectedLocation: existingCartItems[0]?.selectedLocation || "",
    };

    const calculatedTotal = existingCartItems.reduce(
      (sum, item) => sum + parseFloat(item.amountWithIgst || 0),
      0,
    );

    setFormData(initialFormData);
    setCartItems(existingCartItems);
    setTotal(calculatedTotal);
  }, []);
  const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const handlePrint = () => {
    // Create a new window for printing only the quotation
    const printWindow = window.open("", "_blank", "width=800,height=600");

    const quotationContent = document.querySelector(".quotation-content");

    if (printWindow && quotationContent) {
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Quotation - ${quotationNumber}</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              font-size: 12px;
              line-height: 1.4;
              color: #000;
              background: white;
            }
            
            .quotation-content {
              max-width: 210mm;
              margin: 0 auto;
              padding: 20mm;
              background: white;
            }
            
            .border-b-2 { border-bottom: 2px solid #1f2937; }
            .border-b { border-bottom: 1px solid #d1d5db; }
            .border-t { border-top: 1px solid #d1d5db; }
            .border { border: 1px solid #d1d5db; }
            .border-gray-300 { border-color: #d1d5db; }
            .border-gray-400 { border-color: #9ca3af; }
            .border-gray-800 { border-color: #1f2937; }
            
            .bg-gray-50 { background-color: #f9fafb; }
            .bg-gray-100 { background-color: #f3f4f6; }
            
            .text-gray-600 { color: #4b5563; }
            .text-gray-700 { color: #374151; }
            .text-gray-800 { color: #1f2937; }
            
            .font-bold { font-weight: 700; }
            .font-semibold { font-weight: 600; }
            .font-medium { font-weight: 500; }
            
            .text-xs { font-size: 10px; }
            .text-sm { font-size: 11px; }
            .text-base { font-size: 12px; }
            .text-lg { font-size: 14px; }
            .text-xl { font-size: 16px; }
            .text-2xl { font-size: 20px; }
            .text-3xl { font-size: 24px; }
            
            .grid { display: grid; }
            .grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
            .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
            .gap-2 { gap: 8px; }
            .gap-4 { gap: 16px; }
            .gap-6 { gap: 24px; }
            .gap-8 { gap: 32px; }
            
            .flex { display: flex; }
            .flex-col { flex-direction: column; }
            .flex-row { flex-direction: row; }
            .items-start { align-items: flex-start; }
            .items-center { align-items: center; }
            .items-end { align-items: flex-end; }
            .justify-between { justify-content: space-between; }
            .justify-end { justify-content: flex-end; }
            
            .w-full { width: 100%; }
            .w-32 { width: 128px; }
            .w-40 { width: 160px; }
            .w-80 { width: 320px; }
            
            .mb-2 { margin-bottom: 8px; }
            .mb-3 { margin-bottom: 12px; }
            .mb-4 { margin-bottom: 16px; }
            .mb-6 { margin-bottom: 24px; }
            .mb-8 { margin-bottom: 32px; }
            .mt-1 { margin-top: 4px; }
            .mt-2 { margin-top: 8px; }
            .mt-8 { margin-top: 32px; }
            .mt-12 { margin-top: 48px; }
            .ml-auto { margin-left: auto; }
            
            .pb-1 { padding-bottom: 4px; }
            .pb-4 { padding-bottom: 16px; }
            .pb-6 { padding-bottom: 24px; }
            .pt-2 { padding-top: 8px; }
            .pt-4 { padding-top: 16px; }
            .pt-6 { padding-top: 24px; }
            .px-2 { padding-left: 8px; padding-right: 8px; }
            .px-3 { padding-left: 12px; padding-right: 12px; }
            .px-4 { padding-left: 16px; padding-right: 16px; }
            .py-2 { padding-top: 8px; padding-bottom: 8px; }
            .py-3 { padding-top: 12px; padding-bottom: 12px; }
            .p-3 { padding: 12px; }
            .p-4 { padding: 16px; }
            
            .space-y-1 > * + * { margin-top: 4px; }
            .space-y-2 > * + * { margin-top: 8px; }
            
            .rounded-lg { border-radius: 8px; }
            .inline-block { display: inline-block; }
            .text-left { text-align: left; }
            .text-right { text-align: right; }
            .text-center { text-align: center; }
            
            .min-w-16 { min-width: 64px; }
            .min-w-20 { min-width: 80px; }
            
            .overflow-x-auto { overflow-x: auto; }
            .border-collapse { border-collapse: collapse; }
            
            table {
              width: 100%;
              border-collapse: collapse;
            }
            
            th, td {
              border: 1px solid #d1d5db;
              padding: 8px 12px;
              text-align: left;
            }
            
            th {
              background-color: #f9fafb;
              font-weight: 600;
            }
            
            .text-right { text-align: right; }
            
            @media print {
              @page {
                size: A4;
                margin: 0.5in;
              }
              
              body {
                font-size: 11px;
              }
              
              .quotation-content {
                padding: 0;
                margin: 0;
                max-width: none;
              }
              
              table {
                page-break-inside: auto;
              }
              
              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }
              
              thead {
                display: table-header-group;
              }
              
              tfoot {
                display: table-footer-group;
              }
            }
          </style>
        </head>
        <body>
          ${quotationContent.outerHTML}
        </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      // Wait for content to load then print
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
    }
    setIsLoading(false);
  };

  // const handleDownloadPDF = () => {
  //   const element = document.querySelector(".quotation-content");
  //   if (!element) return;
  //   setIsGeneratingPDF(true); // Start loading
  //   const clonedElement = element.cloneNode(true);
  //   const wrapper = document.createElement("div");
  //   wrapper.appendChild(clonedElement);

  //   const styles = `
  //   <style>
  //     * {
  //       margin: 0;
  //       padding: 0;
  //       box-sizing: border-box;
  //     }

  //     body {
  //       font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  //       font-size: 12px;
  //       line-height: 1.4;
  //       color: #000;
  //       background: white;
  //     }

  //     .quotation-content {
  //       max-width: 210mm;
  //       margin: 0 auto;
  //       padding: 20mm;
  //       background: white;
  //     }

  //     .border-b-2 { border-bottom: 2px solid #1f2937; }
  //     .border-b { border-bottom: 1px solid #d1d5db; }
  //     .border-t { border-top: 1px solid #d1d5db; }
  //     .border { border: 1px solid #d1d5db; }
  //     .border-gray-300 { border-color: #d1d5db; }
  //     .border-gray-400 { border-color: #9ca3af; }
  //     .border-gray-800 { border-color: #1f2937; }

  //     .bg-gray-50 { background-color: #f9fafb; }
  //     .bg-gray-100 { background-color: #f3f4f6; }

  //     .text-gray-600 { color: #4b5563; }
  //     .text-gray-700 { color: #374151; }
  //     .text-gray-800 { color: #1f2937; }

  //     .font-bold { font-weight: 700; }
  //     .font-semibold { font-weight: 600; }
  //     .font-medium { font-weight: 500; }

  //     .text-xs { font-size: 10px; }
  //     .text-sm { font-size: 11px; }
  //     .text-base { font-size: 12px; }
  //     .text-lg { font-size: 14px; }
  //     .text-xl { font-size: 16px; }
  //     .text-2xl { font-size: 20px; }
  //     .text-3xl { font-size: 24px; }

  //     .flex { display: flex; }
  //     .flex-col { flex-direction: column; }
  //     .flex-row { flex-direction: row; }
  //     .items-start { align-items: flex-start; }
  //     .items-center { align-items: center; }
  //     .items-end { align-items: flex-end; }
  //     .justify-between { justify-content: space-between; }
  //     .justify-end { justify-content: flex-end; }

  //     .w-full { width: 100%; }
  //     .w-2\\/3 { width: 66.666667%; }
  //     .w-1\\/3 { width: 33.333333%; }
  //     .w-16 { width: 64px; }

  //     .mb-6 { margin-bottom: 24px; }
  //     .pb-4 { padding-bottom: 16px; }
  //     .px-4 { padding-left: 16px; padding-right: 16px; }
  //     .py-3 { padding-top: 12px; padding-bottom: 12px; }

  //     .text-right { text-align: right; }

  //     table { width: 100%; border-collapse: collapse; }
  //     td, th { border: 1px solid #d1d5db; padding: 8px; }
  //   </style>
  // `;

  //   const html = `
  //   <html>
  //   <title>Quotation - ${quotationNumber}</title>
  //     <head>${styles}</head>
  //     <body class="bg-white">
  //       ${wrapper.innerHTML}
  //     </body>
  //   </html>
  // `;

  //   const blob = new Blob([html], { type: "text/html" });
  //   const blobURL = URL.createObjectURL(blob);

  //   const iframe = document.createElement("iframe");
  //   iframe.style.display = "none";
  //   iframe.src = blobURL;
  //   document.body.appendChild(iframe);

  //   iframe.onload = () => {
  //     const iframeDocument =
  //       iframe.contentDocument || iframe.contentWindow.document;
  //     html2pdf()
  //       .from(iframeDocument.body)
  //       .save(`Quotation-${quotationNumber}.pdf`)
  //       .then(() => {
  //         document.body.removeChild(iframe);
  //         setIsGeneratingPDF(false); // Stop loading
  //       })
  //       .catch(() => {
  //         setIsGeneratingPDF(false); // Stop on error too
  //       });
  //   };
  // };

  function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = url;
    });
  }

  // Usage
  getBase64ImageFromURL(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt2dkX9kqZuRHTF_U_QIgIp_GziZjoTjkF3A&s",
  )
    .then((base64Image) => {
      console.log(base64Image);
      // Use this base64Image in your handleDownloadPDF function
    })
    .catch((error) => {
      console.error(error);
    });

  const handleDownloadPDF = async () => {
    const element = document.querySelector(".quotation-content");
    if (!element) return;

    // Clone the HTML
    const clonedElement = element.cloneNode(true);

    // Remove or override the hidden class for the company header
    const companyHeader = clonedElement.querySelector(".hidden.print\\:block");
    if (companyHeader) {
      companyHeader.classList.remove("hidden");
      companyHeader.style.display = "block";
    }

    // Get base64 image
    let base64Image = "";
    try {
      base64Image = await getBase64ImageFromURL(
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt2dkX9kqZuRHTF_U_QIgIp_GziZjoTjkF3A&s",
      );
    } catch (error) {
      console.error("Error loading image:", error);
    }

    // Replace the image src with the base64 image
    const img = clonedElement.querySelector("img");
    if (img) {
      img.src = base64Image;
    }

    // Create a temporary container with a frame
    const wrapper = document.createElement("div");
    wrapper.className = "pdf-frame";
    wrapper.appendChild(clonedElement);

    // Inject Tailwind CDN and additional styles
    const tailwindStyles = `
    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
    <style>
      /* Style for the PDF frame */
      .pdf-frame {
        border: 2px solid #000; /* Adjust the border width and color as needed */
        padding: 20px; /* Adjust the padding as needed to provide space inside the frame */
        margin: 20px; /* Adjust the margin as needed to provide space outside the frame */
      }

      /* Additional styles to ensure the company header is visible */
      .company-header {
        display: table !important;
        width: 100% !important;
        border-collapse: collapse !important;
      }
      .company-header td {
        border: 1px solid #d1d5db !important;
        padding: 8px !important;
        vertical-align: top !important;
      }
      .company-header img {
        max-width: 80px !important;
        max-height: 80px !important;
      }

      /* Your existing styles */
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 12px;
        line-height: 1.4;
        color: #000;
        background: white;
      }

      .quotation-content {
        max-width: 210mm;
        margin: 0 auto;
        padding: 20mm;
        background: white;
      }

      /* Additional CSS styles as needed */
      .border-b-2 { border-bottom: 2px solid #1f2937; }
      .border-b { border-bottom: 1px solid #d1d5db; }
      .border-t { border-top: 1px solid #d1d5db; }
      .border { border: 1px solid #d1d5db; }
      .border-gray-300 { border-color: #d1d5db; }
      .border-gray-400 { border-color: #9ca3af; }
      .border-gray-800 { border-color: #1f2937; }

      .bg-gray-50 { background-color: #f9fafb; }
      .bg-gray-100 { background-color: #f3f4f6; }

      .text-gray-600 { color: #4b5563; }
      .text-gray-700 { color: #374151; }
      .text-gray-800 { color: #1f2937; }

      .font-bold { font-weight: 700; }
      .font-semibold { font-weight: 600; }
      .font-medium { font-weight: 500; }

      .text-xs { font-size: 10px; }
      .text-sm { font-size: 11px; }
      .text-base { font-size: 12px; }
      .text-lg { font-size: 14px; }
      .text-xl { font-size: 16px; }
      .text-2xl { font-size: 20px; }
      .text-3xl { font-size: 24px; }

      .grid { display: grid; }
      .grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
      .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      .gap-2 { gap: 8px; }
      .gap-4 { gap: 16px; }
      .gap-6 { gap: 24px; }
      .gap-8 { gap: 32px; }

      .flex { display: flex; }
      .flex-col { flex-direction: column; }
      .flex-row { flex-direction: row; }
      .items-start { align-items: flex-start; }
      .items-center { align-items: center; }
      .items-end { align-items: flex-end; }
      .justify-between { justify-content: space-between; }
      .justify-end { justify-content: flex-end; }

      .w-full { width: 100%; }
      .w-32 { width: 128px; }
      .w-40 { width: 160px; }
      .w-80 { width: 320px; }

      .mb-2 { margin-bottom: 8px; }
      .mb-3 { margin-bottom: 12px; }
      .mb-4 { margin-bottom: 16px; }
      .mb-6 { margin-bottom: 24px; }
      .mb-8 { margin-bottom: 32px; }
      .mt-1 { margin-top: 4px; }
      .mt-2 { margin-top: 8px; }
      .mt-8 { margin-top: 32px; }
      .mt-12 { margin-top: 48px; }
      .ml-auto { margin-left: auto; }

      .pb-1 { padding-bottom: 4px; }
      .pb-4 { padding-bottom: 16px; }
      .pb-6 { padding-bottom: 24px; }
      .pt-2 { padding-top: 8px; }
      .pt-4 { padding-top: 16px; }
      .pt-6 { padding-top: 24px; }
      .px-2 { padding-left: 8px; padding-right: 8px; }
      .px-3 { padding-left: 12px; padding-right: 12px; }
      .px-4 { padding-left: 16px; padding-right: 16px; }
      .py-2 { padding-top: 8px; padding-bottom: 8px; }
      .py-3 { padding-top: 12px; padding-bottom: 12px; }
      .p-3 { padding: 12px; }
      .p-4 { padding: 16px; }

      .space-y-1 > * + * { margin-top: 4px; }
      .space-y-2 > * + * { margin-top: 8px; }

      .rounded-lg { border-radius: 8px; }
      .inline-block { display: inline-block; }
      .text-left { text-align: left; }
      .text-right { text-align: right; }
      .text-center { text-align: center; }

      .min-w-16 { min-width: 64px; }
      .min-w-20 { min-width: 80px; }

      .overflow-x-auto { overflow-x: auto; }
      .border-collapse { border-collapse: collapse; }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #d1d5db;
        padding: 8px 12px;
        text-align: left;
      }

      th {
        background-color: #f9fafb;
        font-weight: 600;
      }

      .text-right { text-align: right; }

      @media print {
        @page {
          size: A4;
          margin: 0.5in;
        }

        body {
          font-size: 11px;
        }

        .quotation-content {
          padding: 0;
          margin: 0;
          max-width: none;
        }

        table {
          page-break-inside: auto;
        }

        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        thead {
          display: table-header-group;
        }

        tfoot {
          display: table-footer-group;
        }
      }
    </style>
  `;

    const fullHtml = `
    <html>
      <head>
        ${tailwindStyles}
      </head>
      <body class="bg-white p-4">
        ${wrapper.outerHTML}
      </body>
    </html>
  `;

    // Convert to blob and create iframe for html2pdf
    const blob = new Blob([fullHtml], { type: "text/html" });
    const blobURL = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobURL;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;
      html2pdf()
        .from(iframeDocument.body)
        .save(`Quotation-${quotationNumber}.pdf`);
      document.body.removeChild(iframe);
    };
    setIsLoading(false);
  };

  const handlePrintOrDownload = async () => {
    try {
      setIsLoading(true);

      const cartItemsDetails = existingCartItems
        .map((item, index) => {
          return `(${index + 1}) Product: ${item.productName}, Pattern: ${
            item.productsPattern || "Standard"
          }, Rate: ₹${item.rate}, Area: ${item.sqft} sq ft, Apply Area: ${
            item.Area
          }, Discount: ${item.discount}%, Effective Rate: ₹${
            item.effectiveRate
          }, Subtotal: ₹${item.amount}, Total: ₹${parseFloat(
            item.amountWithIgst || 0,
          ).toFixed(2)} (incl. taxes)`;
        })
        .join("\n");

      const total = existingCartItems.reduce(
        (sum, item) => sum + parseFloat(item.amountWithIgst || 0),
        0,
      );

      const message = `New order from ${formData.name}. Address: ${
        formData.address
      }, Pincode: ${formData.pincode}, Location: ${
        formData.selectedLocation
      }\n\nOrder Details:\n${cartItemsDetails}\n\nTotal Amount: ₹${total.toFixed(
        2,
      )}`;

      const response = await fetch(
        `https://webadmin.heritagetextures.in/api/save_contact?name=${encodeURIComponent(
          formData.name,
        )}&phone=${encodeURIComponent(
          formData.mobile,
        )}&email=${encodeURIComponent("-")}&msg=${encodeURIComponent(message)}`,
      );

      if (!response.ok) {
        throw new Error("Failed to send contact information.");
      }

      // Continue with print or download
      if (isMobile()) {
        handleDownloadPDF(); // Mobile: Download as PDF
      } else {
        handlePrint(); // Desktop: Print window
      }
    } catch (error) {
      console.error("Error in handlePrintOrDownload:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const currentDate = new Date().toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const quotationNumber = `QT-${Date.now().toString().slice(-6)}`;

  return (
    <>
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 ">
        <div className="h-full w-full overflow-y-auto p-2 sm:p-4 md:p-6 lg:p-8">
          <div className="min-h-full flex items-center justify-center">
            <div className="relative w-full max-w-7xl mx-auto bg-white rounded-lg shadow-xl">
              {/* Header with Actions - Hidden on Print */}
              <div className="sticky top-0 bg-white border-b border-gray-200 px-3 sm:px-6 py-3 sm:py-4 rounded-t-lg print:hidden z-10">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                  <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                    Quotation Preview
                  </h2>
                  <div className="flex items-center gap-2 w-full sm:w-auto">
                    <button
                      onClick={handlePrintOrDownload}
                      disabled={isLoading}
                      className="flex-1 px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 flex items-center justify-center gap-2 text-sm"
                    >
                      {isLoading ? (
                        <span className="flex items-center gap-2">
                          <svg
                            className="animate-spin h-4 w-4 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            />
                          </svg>
                          <span className="inline">Generating...</span>
                        </span>
                      ) : (
                        <>
                          <Printer className="w-5 h-5" />
                          <span className="inline">Print</span>
                          <span className="inline mx-1">/</span>
                          <Download className="w-5 h-5" />
                          <span className="inline">PDF</span>
                        </>
                      )}
                    </button>

                    {/* <button
                      onClick={handleDownload}
                      className="flex-1 sm:flex-none px-3 sm:px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors duration-200 flex items-center justify-center gap-2 text-sm"
                    >
                      <Download className="w-4 h-4" />
                      <span className="hidden sm:inline">PDF</span>
                    </button> */}
                    <button
                      onClick={onClose}
                      disabled={isLoading}
                      className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-1"
                      aria-label="Close quotation modal"
                    >
                      <svg
                        className="w-5 h-5 sm:w-6 sm:h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Document Content */}
              <div className="quotation-content p-3 sm:p-6 md:p-8 lg:p-12">
                {/* Company Header */}
                <div className="quotation-content p-3 sm:p-6 md:p-8 lg:p-12">
                  {/* Company Header - Screen Version */}

                  {/* Company Header - Print Version (Table Format) */}
                  <div
                    className={`hidden print:block border-b-2 border-gray-800 pb-4 mb-6`}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        <tr>
                          {/* Company Details Section */}
                          <td
                            style={{
                              width: "66.666667%",
                              paddingRight: "16px",
                              verticalAlign: "top",
                            }}
                          >
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      width: "80px",
                                      verticalAlign: "center",
                                      paddingRight: "16px",
                                      paddingBottom: "16px",
                                    }}
                                  >
                                    {/* Logo Cell */}
                                    <div
                                      style={{
                                        width: "150px",
                                        height: "64px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <img
                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt2dkX9kqZuRHTF_U_QIgIp_GziZjoTjkF3A&s"
                                        alt="Rigve Logo"
                                        style={{
                                          maxWidth: "100%",
                                          maxHeight: "100%",
                                          objectFit: "contain",
                                          width: "140px",
                                          height: "80px",
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td style={{ verticalAlign: "top" }}>
                                    {/* Company Name and Details */}
                                    <div>
                                      <h1
                                        style={{
                                          fontSize: "24px",
                                          fontWeight: "bold",
                                          color: "#1f2937",
                                          lineHeight: "1.25",
                                          marginBottom: "12px",
                                          margin: "0 0 12px 0",
                                        }}
                                      >
                                        Heritage Textures
                                      </h1>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#4b5563",
                                          lineHeight: "1.5",
                                        }}
                                      >
                                        <p style={{ margin: "4px 0" }}>
                                          Darbar Faliyu, 29/1, opp. Vishwanath
                                          Society,
                                        </p>
                                        <p style={{ margin: "4px 0" }}>
                                          Aanad Dhara Society Gate, Mota
                                          Varachha,
                                        </p>
                                        <p style={{ margin: "4px 0" }}>
                                          Surat, Gujarat 394101
                                        </p>
                                        <p style={{ margin: "4px 0" }}>
                                          Phone: +91 9427986568 | Email:
                                          info.naturx@gmail.com
                                        </p>
                                        <p style={{ margin: "4px 0" }}>
                                          GST: 24AERF52914J1ZP
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          {/* Quotation Number Section */}
                          <td
                            style={{
                              width: "20.333333%",
                              verticalAlign: "top",
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                border: "2px solid #1f2937",
                                padding: "12px 16px",
                                display: "inline-block",
                              }}
                            >
                              <h2
                                style={{
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  margin: "0 0 4px 0",
                                }}
                              >
                                QUOTATION
                              </h2>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#4b5563",
                                  margin: "0",
                                }}
                              >
                                #{quotationNumber}
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Customer and Quotation Details */}
                <div className="mb-6 sm:mb-8">
                  {/* Single table with both customer and quotation details */}
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm sm:text-base font-semibold text-gray-800">
                            Customer Details
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm sm:text-base font-semibold text-gray-800">
                            Quotation Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2 align-top">
                            <div className="space-y-2 text-xs sm:text-sm">
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-16">
                                  Name:
                                </span>
                                <span className="sm:ml-2">{formData.name}</span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-16">
                                  Mobile:
                                </span>
                                <span className="sm:ml-2">
                                  {formData.mobile}
                                </span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-16">
                                  Address:
                                </span>
                                <span className="sm:ml-2">
                                  {formData.address}
                                </span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-16">
                                  Pincode:
                                </span>
                                <span className="sm:ml-2">
                                  {formData.pincode}
                                </span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-16">
                                  Location:
                                </span>
                                <span className="sm:ml-2">
                                  {formData.selectedLocation}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="border border-gray-300 px-4 py-2 align-top">
                            <div className="space-y-2 text-xs sm:text-sm">
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-20">
                                  Date:
                                </span>
                                <span className="sm:ml-2">{currentDate}</span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-20">
                                  Valid Until:
                                </span>
                                <span className="sm:ml-2">
                                  {new Date(
                                    Date.now() + 30 * 24 * 60 * 60 * 1000,
                                  ).toLocaleDateString("en-IN", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-20">
                                  Payment:
                                </span>
                                <span className="sm:ml-2">30 days</span>
                              </div>
                              <div className="flex flex-col sm:flex-row">
                                <span className="font-medium min-w-20">
                                  Delivery:
                                </span>
                                <span className="sm:ml-2">
                                  7-10 business days
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Items Table */}
                <div className="mb-6 sm:mb-8 no-print">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4 border-b border-gray-300 pb-1">
                    Items & Details
                  </h3>

                  {/* Desktop View - Table Layout */}
                  <div className="">
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300 text-xs sm:text-sm">
                        <thead>
                          <tr className="bg-gray-50">
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-left font-medium">
                              S.No
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-left font-medium">
                              Product
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-left font-medium">
                              Pattern
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-left font-medium">
                              Area
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                              Rate (₹)
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                              Sq.Ft
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                              Disc(%)
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                              Eff.Rate(₹)
                            </th>
                            <th className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                              Amount (₹)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((item, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="border border-gray-300 px-2 sm:px-3 py-2">
                                {index + 1}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2">
                                {item.productName}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2">
                                {item.productsPattern || "Standard"}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2">
                                {item.Area}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2 text-right">
                                ₹{item.rate}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2 text-right">
                                {item.sqft}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2 text-right">
                                {item.discount}%
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2 text-right">
                                ₹{item.effectiveRate}
                              </td>
                              <td className="border border-gray-300 px-2 sm:px-3 py-2 text-right font-medium">
                                ₹
                                {parseFloat(item.amountWithIgst || 0).toFixed(
                                  2,
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Total Section */}
                <div className="flex justify-end mb-6 sm:mb-8">
                  <div className="w-full sm:w-80">
                    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
                      <div className="space-y-2">
                        <div className="flex justify-between text-xs sm:text-sm">
                          <span>Subtotal:</span>
                          <span>
                            ₹
                            {cartItems
                              .reduce(
                                (sum, item) =>
                                  sum + parseFloat(item.amount || 0),
                                0,
                              )
                              .toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between text-xs sm:text-sm">
                          <span>IGST (18%):</span>
                          <span>
                            ₹
                            {(
                              total -
                              cartItems.reduce(
                                (sum, item) =>
                                  sum + parseFloat(item.amount || 0),
                                0,
                              )
                            ).toFixed(2)}
                          </span>
                        </div>
                        <div className="border-t border-gray-300 pt-2">
                          <div className="flex justify-between text-sm sm:text-lg font-bold">
                            <span>Total Amount:</span>
                            <span>₹{total.toFixed(2)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Terms and Conditions */}
                <div className="mb-6 sm:mb-8">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 border-b border-gray-300 pb-1">
                    Terms & Conditions
                  </h3>
                  <div className="text-xs sm:text-sm text-gray-700 space-y-1">
                    <p>
                      • This quotation is valid for 30 days from the date of
                      issue.
                    </p>
                    <p>• Payment terms: 30 days from delivery.</p>
                    <p>
                      • Delivery will be made within 7-10 business days after
                      order confirmation.
                    </p>
                    <p>
                      • Installation charges are not included in the quoted
                      price.
                    </p>
                    <p>
                      • Any additional requirements will be charged separately.
                    </p>
                    <p>
                      • This quotation is subject to our standard terms and
                      conditions.
                    </p>
                    <p>
                      <strong>Warranty:</strong> NO PART OF WORK CONTRACT IS
                      WARRANTED
                    </p>
                    <p>
                      <strong>Bank Details:</strong>
                    </p>
                    <p>Punjab National Bank</p>
                    <p>A/C Name: Straight Line Wall Texture LLP</p>
                    <p>A/C Number: 9727002100001968</p>
                    <p>IFSC: PUNB0972700</p>
                    <p>
                      1. Advance once processed will not be refunded under any
                      circumstance.
                    </p>
                    <p>
                      2. Once advance is processed, it implicitly states that
                      you agree to terms and conditions mentioned in this.
                    </p>
                    <p>
                      3. The estimate is based on measurement provided. The
                      final billing will be based on actual area.
                    </p>
                    <p>
                      4. The price includes Material and Labour. Surfaces less
                      than 1 feet in width will be considered 1 feet.
                    </p>
                    <p>
                      5. Project will start on approx. 30 days from the date of
                      advance payment, Color Selections, Signed.
                    </p>
                    <p>
                      6. Once project starts it will take approx. 4 to 6 days to
                      complete the project once started.
                    </p>
                    <p>
                      7. On completion of the project, the remaining balance of
                      25% should be paid within 3 Days. Strictly No Retention
                      allowed. If Not paid 24% interest will be charged per
                      annum.
                    </p>
                    <p>
                      8. The terms and conditions in this document supersede
                      other documents like your Purchase Order, Work Order, etc.
                    </p>
                    <p>
                      9. The Quotation is valid for 30 days. We reserve the
                      right to change the prices or withdraw the quotation until
                      you sign this document and process the advance.
                    </p>
                    <p>
                      10. The entire project has to be executed in a single
                      phase. We will not be able to break the project into
                      multiple phases.
                    </p>
                    <p>
                      11. If the project is delayed from your side, the new
                      schedule has to be worked out mutually. We can only agree
                      to dates when our resources are available.
                    </p>
                    <p>
                      12. Lime Plaster Color Shades vary around 25% from the
                      chosen color due to manual application, compression and
                      distribution of pigments. Lime Plaster is applied by hand
                      so uniform application like Paint is not possible, nor we
                      would try to mimic paint. Variation in texture is natural.
                      It is considered normal and should not be treated as an
                      application defect.
                    </p>
                    <p>
                      13. Our material is very thick, it will not be possible to
                      apply it inside the grooves and small areas. You will have
                      to get it painted after our work is completed.
                    </p>
                    <p>
                      14. Provide plumb walls with 2 Coat Water-based primer
                      applied on it. Erected double metal scaffolding has to be
                      provided by you.
                    </p>
                    <p>
                      15. If our product is applied on Wood or Gypsum Panels,
                      the risk of joint cracking is very high. You will have to
                      apply reinforcement tapes and fill the joints with
                      high-quality adhesives.
                    </p>
                    <p>
                      16. In any case, we do not warranty the cracks. Any
                      re-work arising due to cracks will be charged.
                    </p>
                    <p>
                      17. Please note that this product is very difficult to
                      touch-up if there is any damage after our work is
                      completed. Make sure all other work is completed before
                      Limocoat work starts.
                    </p>
                    <p>
                      18. Lime Plaster is absorbent so care should be taken to
                      cover it with plastic, etc. during any other work nearby.
                      For example, Polishing of marbles, Painting of Ceiling,
                      etc.
                    </p>
                    <p>
                      19. For work scheduling please treat Lime Plaster as Wall
                      Paper / Finish Paint, meaning that it should be the last
                      thing in the schedule, just before installation of
                      fittings, etc. A dust-free site is required.
                    </p>
                    <p>
                      20. Existing electric cables, light fixtures, Air
                      conditioners, and other office furniture have to be
                      removed and installed by you if required.
                    </p>
                    <p>
                      21. You will pay for clearance of Debris from the site.
                    </p>
                    <p>
                      22. You will have to supply free electricity and free
                      water during the execution of the project.
                    </p>
                    <p>
                      23. You will have to provide a secured area at the site to
                      store our material and equipment.
                    </p>
                    <p>
                      24. You will have to take necessary municipal / local
                      bodies permissions and pay for it.
                    </p>
                    <p>
                      25. Heritage Textures is just a supplier of the products.
                    </p>
                    <p>
                      26. We as an applicator are responsible for actual
                      application and the quality of the finishes.
                    </p>
                    <p>
                      <strong>Measurement Options:</strong>
                    </p>
                    <p>
                      1: Joint Measurement: 100% joint measurement Within 3 Days
                      of completion of project. (No Additional Charges)
                    </p>
                    <p>
                      2: Spot Check Measurement: We will do the measurement
                      alone, You can verify a maximum of 10% of the project.
                      Within 3 Days of completion of project. (No Additional
                      Charges)
                    </p>
                    <p>
                      3: Repeat Measurement: We will do 100% measurement and you
                      will verify 100% measurement. Within 7 Days of completion
                      of project. Additional Rs.5/- per sqft charge applicable
                    </p>
                    <p>
                      4: Third Party Measurement: A professional agency will do
                      the measurement. (You will pay 100% of the agency charges)
                    </p>
                    <p>
                      5: Any Other Method: Any other method from your side.
                      Provide details….Provide your method procedure and
                      documentation (Additional Charges may apply)
                    </p>
                    <p>Option Selected ______</p>
                    <p>Customer Signature_________________________</p>
                  </div>
                </div>

                {/* Footer */}
                <div className="border-t border-gray-300 pt-4 sm:pt-6">
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
                    <div className="text-xs sm:text-sm text-gray-600">
                      <p>Thank you for your business!</p>
                      <p>
                        For any queries, please contact us at the above details.
                      </p>
                    </div>
                    <div className="w-full sm:w-auto text-center sm:text-right">
                      <div className="border-t border-gray-400 pt-2 mt-8 sm:mt-12 w-32 sm:w-40 ml-auto">
                        <p className="text-xs sm:text-sm text-gray-600">
                          Authorized Signature
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Actions - Hidden on Print */}
              <div className="px-3 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200 rounded-b-lg print:hidden">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                  <p className="text-xs sm:text-sm text-gray-600">
                    Total Amount: ₹{total.toFixed(2)}
                  </p>
                  <button
                    onClick={onClose}
                    disabled={isLoading}
                    className="w-full sm:w-auto px-4 sm:px-6 py-2 bg-gray-500 text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-200"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          body {
            margin: 0;
            padding: 0;
            font-size: 12px;
          }

          .quotation-content {
            padding: 20px !important;
            max-width: none !important;
            width: 100% !important;
          }

          /* Ensure flex classes are applied during printing */
          .flex {
            display: flex !important;
          }

          .flex-col {
            flex-direction: column !important;
          }

          .flex-row {
            flex-direction: row !important;
          }

          .justify-between {
            justify-content: space-between !important;
          }

          .items-start {
            align-items: flex-start !important;
          }

          .gap-4 {
            gap: 1rem !important;
          }

          /* Ensure grid classes are applied during printing */
          .grid {
            display: grid !important;
          }

          .grid-cols-1 {
            grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
          }

          .lg\:grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }

          .gap-6,
          .sm\:gap-8 {
            gap: 1.5rem !important;
          }

          .mb-6,
          .sm\:mb-8 {
            margin-bottom: 1.5rem !important;
          }

          @page {
            size: A4;
            margin: 0.5in;
          }

          .quotation-content table {
            page-break-inside: auto;
          }

          .quotation-content tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .quotation-content thead {
            display: table-header-group;
          }

          .quotation-content tfoot {
            display: table-footer-group;
          }
        }
      `}</style>
    </>
  );
};

export default QuotationModal;
